export class FamilyModel {
  familyId: number = 0;
  code: string = '';
  name: string = '';
  alterCode: string | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
